module.exports = __webpack_public_path__ + "static/img/1.cb6c6e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/plans/snip3down/1.png
// module id = nTc8
// module chunks = 35